export const useTextOverflow = (description: string, maxTextLength: number) => {
  return description.length > maxTextLength;
};
